import { useFormContext } from 'react-hook-form';
import { ProductResult, Service, useRepositoryQuery } from '@mews-commander/data-access';
import { useGetServiceProductsCurrency } from '../hooks/useGetServiceProductsCurrency';
import { TotalBar } from './TotalBar';
import { AddProductFormValues } from './schema';
import { getTotalAmount } from './utils';

interface Props {
    service: Service;
    productsData: ProductResult;
}

export const TotalBarWithData = ({ service, productsData }: Props) => {
    const { data: exchangeRates } = useRepositoryQuery('currencyAcceptances', 'getAll', {});

    const { watch } = useFormContext<AddProductFormValues>();
    const formValues = watch();

    const { currency, hasSingleCurrency } = useGetServiceProductsCurrency(productsData.products || [], service);
    const countSelected = (formValues.productOrders || []).reduce((acc, po) => acc + (po.count || 0), 0);

    const totalAmount = getTotalAmount({
        hasSingleCurrency,
        formValues,
        exchangeRates,
        serviceCurrency: formValues.currency,
    });

    // every service has 1 default product, that's why ` - 1`
    const visibleProductsCount = productsData.products ? productsData.products.length - 1 : 0;

    return (
        <TotalBar
            currency={currency}
            totalAmount={totalAmount}
            hasSingleCurrency={hasSingleCurrency}
            count={countSelected}
            hasProducts={visibleProductsCount > 0}
        />
    );
};
